/**
 * Declared commerce-backoffice Pattern identity.
 *
 * This registry mirrors every `cobo:*Pattern` class declared in
 * cogo-commerce-backoffice-v1.ttl. It intentionally includes declared
 * patterns with no admitted corpus instances; retrieval support is owned by
 * the generator and may be narrower than this TBox identity surface.
 */
export const COBO_TBOX_TO_ARCHETYPE = Object.freeze({
  ListViewPattern: "list-view",
  EditableListViewPattern: "editable-list-view",
  DetailViewPattern: "detail-view",
  KpiDashboardPattern: "kpi-dashboard",
  FormSubmitPattern: "form-submit",
  ChartViewPattern: "chart-view",
} as const)

export type CoboTboxPattern = keyof typeof COBO_TBOX_TO_ARCHETYPE
export type CoboArchetype = (typeof COBO_TBOX_TO_ARCHETYPE)[CoboTboxPattern]

export const COBO_ARCHETYPE_TO_TBOX: Readonly<Record<CoboArchetype, CoboTboxPattern>> =
  Object.freeze(
    Object.fromEntries(
      Object.entries(COBO_TBOX_TO_ARCHETYPE).map(([tbox, archetype]) => [archetype, tbox]),
    ) as Record<CoboArchetype, CoboTboxPattern>,
  )

export function coboTboxToArchetype(tbox: string | undefined): CoboArchetype | undefined {
  if (!tbox || !Object.prototype.hasOwnProperty.call(COBO_TBOX_TO_ARCHETYPE, tbox)) {
    return undefined
  }
  return COBO_TBOX_TO_ARCHETYPE[tbox as CoboTboxPattern]
}

export function coboArchetypeToTbox(archetype: string | undefined): CoboTboxPattern | undefined {
  if (
    !archetype ||
    !Object.prototype.hasOwnProperty.call(COBO_ARCHETYPE_TO_TBOX, archetype)
  ) {
    return undefined
  }
  return COBO_ARCHETYPE_TO_TBOX[archetype as CoboArchetype]
}
